import { render, staticRenderFns } from "./ItTable.vue?vue&type=template&id=1237555d"
import script from "./ItTable.vue?vue&type=script&lang=ts"
export * from "./ItTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports